import { render } from "./sygnio_questions.html?vue&type=template&id=414c499f&external"
import script from "./sygnio_questions.js?vue&type=script&lang=js&external"
export * from "./sygnio_questions.js?vue&type=script&lang=js&external"

import "./SygnioQuestions.vue?vue&type=style&index=0&id=414c499f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__